import { msg } from '../messages'
import { onlyUnaccentedLettersAndNumbers } from './onlyLettersAndNumbers'

export function numeroEndereco(semNumero: boolean = false) {
  return (value: string) => {
    if (!semNumero) {
      return onlyUnaccentedLettersAndNumbers(value)
    }
    if (semNumero && value !== 'S/N') {
      return msg('invalid', value)
    }
  }
}
